import React, { useState } from 'react';
import { Flex, Button, VStack, Box } from '@chakra-ui/react';
import { FieldErrors, FieldValues, UseFormGetValues } from 'react-hook-form';

type GetInspiredProps = {
    errors: FieldErrors<FieldValues>;
    register: any;
    getValues: UseFormGetValues<any>;
};

const GetInspired: React.FC<GetInspiredProps> = ({ errors, register, getValues }) => {
    const [files, setFiles] = useState<File[]>([]);

    const handleRemove = (file: File) => {
        const data = getValues();
        setFiles(data['getInspiredFiles'])
        setFiles(files.filter((f) => f !== file));
    };
    return (
        <Box>
            <Box sx={{fontSize: ['35px'], fontWeight: '800' }}>Get Inspired</Box>
            <Flex direction="column" alignItems="center">
                <Button
                    as={'label'}
                    htmlFor={'getInspiredFiles'}
                    variant={'outline'}
                    colorScheme={'teal'}
                    leftIcon={<i className='fas fa-cloud-upload-alt'></i>}
                    w='100%'
                >
                    Upload Files
                </Button>
                <input
                    id={'getInspiredFiles'}
                    type={'file'}
                    accept={'.jpg, .jpeg, .png'}
                    style={{ display: 'none' }}
                    {...register('getInspiredFiles')}
                    multiple="multiple"
                    onChange={(e) => {
                        register('getInspiredFiles').onChange(e);  // React Hook Form's onChange
                        const newFiles = e.target.files!;
                        setFiles([...newFiles, ...files]);
                    }}
                />
                <VStack>
                    {files.map((file, idx) => (
                        <Box key={idx}>
                            {file.name}
                            <Button onClick={() => handleRemove(file)}>Remove</Button>
                        </Box>
                    ))}
                </VStack>
            </Flex>
        </Box>
    )
}

export default GetInspired